import React from 'react';

const IconQueima = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="28"
    height="28"
    viewBox="0 0 28 28"
  >
    <path
      fill="#FC580A"
      fillRule="evenodd"
      d="M12.982 0c2.662 0 4.974.576 6.934 1.726a11.657 11.657 0 0 1 4.512 4.73C25.476 8.458 26 10.685 26 13.137c0 1.702-.24 3.29-.721 4.767a12.99 12.99 0 0 1-2.09 3.978l2.22 2.477L21.265 28l-2.478-2.627c-1.726.8-3.662 1.2-5.806 1.2-2.614 0-4.901-.58-6.861-1.745a11.897 11.897 0 0 1-4.53-4.748C.53 18.08 0 15.852 0 13.4c0-2.578.554-4.886 1.664-6.925 1.11-2.04 2.65-3.628 4.623-4.767C8.26.57 10.491 0 12.982 0zm-.797 4.17c1.199 2.956-.343 7.651-1.524 8.54 0 0-.694-2.135-.009-4.202-2.58 2.27-3.094 5.41-3.094 7.313 0 2.88 2.302 5.216 5.14 5.216 2.84 0 5.14-2.335 5.14-5.216 0-1.923-.332-3.12-1.532-5.033 0 0 .162 2.946-.866 4.51.514-3.303-.685-8.346-3.255-11.128z"
    />
  </svg>
);

export default IconQueima;
